import {post, formDownload} from './http'
const baseUrl = '/api'

// 顶部考试首页推荐信息
export const getQuestionBankTopicIndexsection = v => post(`${baseUrl}/capwhale/questionbanktopic/getQuestionBankTopicIndexsection`, v.data, v.success, v.error)
// 学习榜单排名
export const getStudyRankList = v => post(`${baseUrl}/capwhale/questionbanktopic/getStudyRankList`, v.data, v.success, v.error)
// 资讯详情
export const getQuestionBankTopicContentInfo = v => post(`${baseUrl}/capwhale/questionbanktopic/getQuestionBankTopicContentInfo`, v.data, v.success, v.error)
// 首页热门推荐列表
export const getIndexRecommendContentList = v => post(`${baseUrl}/capwhale/questionbanktopic/getIndexRecommendContentList`, v.data, v.success, v.error)
// 首页各版块的资讯内容
export const getIndexContentList = v => post(`${baseUrl}/capwhale/questionbanktopic/getIndexContentList`, v.data, v.success, v.error)
// 资料下载列表
export const getDocumentList = v => post(`${baseUrl}/capwhale/questionbanktopic/getDocumentList`, v.data, v.success, v.error)
// 首页推荐列表分页
export const getContentListByPage = v => post(`${baseUrl}/capwhale/questionbanktopic/getContentListByPage`, v.data, v.success, v.error)
// 附件下载
export const downloaddocument = v => formDownload(`${baseUrl}/capwhale/questionbanktopic/downloaddocument`, v.data, v.name, v.success, v.error)
// 资料下载列表分页
export const getDocumentListByPage = v => post(`${baseUrl}/capwhale/questionbanktopic/getDocumentListByPage`, v.data, v.success, v.error)
// 按时间获取打卡记录信息
export const getUserPunchinfoByDay = v => post(`${baseUrl}/capwhale/questionbanktopic/getUserPunchinfoByDay`, v.data, v.success, v.error)
// 打卡记录列表
export const getUserPunchinfoList = v => post(`${baseUrl}/capwhale/questionbanktopic/getUserPunchinfoList`, v.data, v.success, v.error)
// 参与打卡
export const uploadUserPunchinfo = v => post(`${baseUrl}/capwhale/questionbanktopic/uploadUserPunchinfo`, v.data, v.success, v.error)